import type { FormValue } from '../../types';

/**
 * Read-time coercion for multi-select values. Saved data can hold a string or
 * null where a list is expected; this never changes the stored value.
 */
export function toStringArray(value: FormValue | undefined): string[] {
  if (Array.isArray(value)) return value as string[];
  if (typeof value === 'string' && value !== '') return [value];
  return [];
}
